import React from "react";
import {
  IonIcon,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent,
  IonProgressBar, withIonLifeCycle,
} from "@ionic/react";
import {
  calendar,
  document,
  basket,
  attach,
  arrowBack,
  fileTrayStacked
} from "ionicons/icons";
import AbaFazenda from "./AbaFazenda";
import AbaEventos from "./AbaEventos";
import {AbaCalendario} from "./AbaCalendario";
import {AbaAnexos} from "./AbaAnexos";
import fb from "../../lib/firebase";
import {goBackNG} from "../../lib/utils";
import {FazendaObject, getFazendaNomeCompleto, prepareFazenda} from "../../models/Fazenda";
import {NavFooter} from "../../components/NavFooter";
import {debug} from "../../config";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";


interface Props {
  match: {params: {instanceId: string}};
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  selectedTab: string;
  instance: FazendaObject | undefined;
  loading: boolean;
}

class Fazenda extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedTab: "home",
      instance: undefined,
      loading: true,
    };

    this.cancelListener = () => {};
  }

  ionViewWillEnter() {
    // reset state
    const instanceId = this.props.match.params.instanceId;
    const instance = this.state.instance;
    if ( !instance || instance.id !== instanceId) {
      this.setState({instance: undefined, loading: true, selectedTab: "home"});
    }

    this.installListener();
  }
  ionViewDidLeave() {
    this.cancelListener();
  }

  installListener = () => {
    const instanceId = this.props.match.params.instanceId;
    // console.log(`Installing listener for ${instanceId}`);
    const doc = fb.db.collection('fazendas').doc(instanceId);
    const _cancelListener = doc.onSnapshot((snap) => {
      const instance = fb.doc(snap);
      debug(`Fazenda ${instance.id}`, instance);
      this.setState({
        instance: instance ? prepareFazenda(instance) : undefined,
        loading: false,
      });
    });
    this.cancelListener = () => {
      // console.log(`Canceling listener for ${instanceId}`);
      _cancelListener();
    }
  };

  onChangeTab = (selectedTab:string) => {
    this.setState({selectedTab});
  };

  onClickBack = () => {
    goBackNG(this.props.app.jumpHistory, this.props.dispatch, this.props);
  };

  render() {
    const tabs:any[] = [
      {
        tab: "home",
        icon: document,
        label: "Cadastro",
      },
      {
        tab: "calendario",
        icon: basket,
        label: "Calendário",
      },
      {
        tab: "historico",
        icon: calendar,
        label: "Histórico",
      },
      {
        tab: "anexos",
        icon: attach,
        label: "Anexos",
      }
    ];

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonButton onClick={this.onClickBack}>
                <IonIcon slot="start" icon={arrowBack}/>
              </IonButton>
            </IonButtons>
            <IonTitle className="font-condensed">
              {this.state.instance &&
                getFazendaNomeCompleto(this.state.instance)
              }
            </IonTitle>
            <IonIcon icon={fileTrayStacked} slot="primary" class="pr-3 text-2xl"/>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {
            !this.state.instance ? <IonProgressBar type="indeterminate"/> :
              <>
                {
                  this.state.selectedTab === "home" &&
                  <AbaFazenda
                    instance={this.state.instance}
                    goBack={this.onClickBack}
                    loading={this.state.loading}
                  />
                }
                {
                  this.state.selectedTab === "calendario" &&
                  <AbaCalendario
                    instance={this.state.instance}
                  />
                }
                {
                  this.state.selectedTab === "historico" &&
                  <AbaEventos
                    instance={this.state.instance}
                    history={this.props.history}
                  />
                }
                {
                  this.state.selectedTab === "anexos" &&
                  <AbaAnexos
                    instance={this.state.instance}
                    history={this.props.history}
                  />
                }
              </>
          }
        </IonContent>
        <NavFooter
          value={this.state.selectedTab}
          onChange={this.onChangeTab}
          tabs={tabs}
        />
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Fazenda));